module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan2-2-d8f5577571e871143e623e9e5f4c065a.webp";